export default {
    text_1: "Moji klienti",
    text_2: "Moji klienti",
    text_3: "Vytvořit klienta",
    text_4: "NÁZEV KLIENTA, FIRMY, OSOBY",
    text_5: "Jméno",
    text_6: "Kontaktní osoba",
    text_7: "Hledat",
    text_8: "E-mail",
    text_9: "Telefonní číslo",
    text_10: "Poslední kontakt",
    text_48: "Společnost",
    text_11: "Připomenout kontakt",
    text_12: "Odvětví",
    text_13: "Poznámky",
    text_14: "Akce",
    text_15: "Upravit",
    text_16: "Smazat",
    text_17: "Jste si jistí?",
    text_18: "Opravdu chcete smazat klienta?",
    text_19: "Ne",
    text_20: "Ano",
    text_21: "Klient byl úspěšně smazán.",

    text_22: "Fakturační údaje",
    text_23:
        "Některé údaje dokážeme vyplnit automaticky. Zadej IČO nebo název firmy.",
    text_24: "Název společnosti",
    text_25: "IČO",
    text_26: "DIČ",
    text_27: "IČ DPH",
    text_28: "Ulice a číslo",
    text_29: "PSČ",
    text_30: "Město",
    text_31: "Kontakty",
    text_32: "Ulož si kontakty na svého klienta.",
    text_33: "Kontaktní osoba",
    text_34: "Email",
    text_35: "Telefonní číslo",
    text_36: "Další informace",
    text_37: "Datum posledního kontaktu",
    text_38: "Odvětví",
    text_39: "Poznámka",

    text_40: "Uložit",
    text_41: "Vytvořit poznámku klienta",

    text_42: "Je třeba vyplnit název klienta.",
    text_43: "Klient byl úspěšně vytvořen.",
    text_44: "Klient byl úspěšně upraven.",
    text_45: "Název klienta již existuje",

    text_46: "Připomenout kontakt e-mailem",
    text_47:
        "Pokud zapneš tuto možnost, můžeš si nastavit datum, kdy ti DOFFERO e-mailem připomene, že se máš ozvat klientovi.",
    text_49: "Aktuálně nemáš vytvořeného žádného klienta.",

    text_50: "Zpět",

    text_51: "Zdroj kontaktu"
};
